let dirPath = 'static/games/page008_game1';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'mapa0',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 'mapa0', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '10',
            correct: [{ idGroup: 'mapa0', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '20',
            correct: [{ idGroup: 'mapa0', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '30',
            correct: [{ idGroup: 'mapa0', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '40',
            correct: [{ idGroup: 'mapa0', idItem: 'legend' }],
          },
        ],
      },
      {
        idGroup: 'mapa1',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 'mapa1', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '11',
            correct: [{ idGroup: 'mapa1', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '21',
            correct: [{ idGroup: 'mapa1', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '31',
            correct: [{ idGroup: 'mapa1', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '41',
            correct: [{ idGroup: 'mapa1', idItem: 'legend' }],
          },
        ],
      },
      {
        idGroup: 'mapa2',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa2', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '12',
            correct: [{ idGroup: 'mapa2', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '22',
            correct: [{ idGroup: 'mapa2', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '32',
            correct: [{ idGroup: 'mapa2', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '42',
            correct: [{ idGroup: 'mapa2', idItem: 'legend' }],
          },
        ],
      },
      {
        idGroup: 'mapa3',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa3', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '13',
            correct: [{ idGroup: 'mapa3', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '23',
            correct: [{ idGroup: 'mapa3', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '33',
            correct: [{ idGroup: 'mapa3', idItem: 'legend' }],
          },
          {
            idGroup: 'source',
            idItem: '43',
            correct: [{ idGroup: 'mapa3', idItem: 'legend' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { size: '40px', textAlign: 'center', textBaseline: 'middle', font: 'Myriad Pro' },
      },
    },
    groups: [
      {
        idGroup: 'mapa0',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'green',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 250 },
                },
                items: [
                  {
                    id: 'hook00',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 663, height: 127, width: 127 } },
                  },
                  {
                    id: 'hook10',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 663, height: 127, width: 127 } },
                  },
                  {
                    id: 'hook20',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 663, height: 127, width: 127 } },
                  },
                  {
                    id: 'hook30',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 663, height: 127, width: 127 } },
                  },
                  {
                    id: 'hook40',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 663, height: 127, width: 127 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'mapa1',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'green',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 250 },
                },
                items: [
                  {
                    id: 'hook01',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1520, y: 480, height: 142, width: 164 } },
                  },
                  {
                    id: 'hook11',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1520, y: 480, height: 142, width: 164 } },
                  },
                  {
                    id: 'hook21',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1520, y: 480, height: 142, width: 164 } },
                  },
                  {
                    id: 'hook31',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1520, y: 480, height: 142, width: 164 } },
                  },
                  {
                    id: 'hook41',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1520, y: 480, height: 142, width: 164 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'mapa2',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'green',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 250 },
                },
                items: [
                  {
                    id: 'hook02',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1525, y: 285, height: 156, width: 156 } },
                  },
                  {
                    id: 'hook12',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1525, y: 285, height: 156, width: 156 } },
                  },
                  {
                    id: 'hook22',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1525, y: 285, height: 156, width: 156 } },
                  },
                  {
                    id: 'hook32',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1525, y: 285, height: 156, width: 156 } },
                  },
                  {
                    id: 'hook42',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1525, y: 285, height: 156, width: 156 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'mapa3',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'green',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 250 },
                },
                items: [
                  {
                    id: 'hook03',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 22, height: 220, width: 126 } },
                  },
                  {
                    id: 'hook13',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 22, height: 220, width: 126 } },
                  },
                  {
                    id: 'hook23',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 22, height: 220, width: 126 } },
                  },
                  {
                    id: 'hook33',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 22, height: 220, width: 126 } },
                  },
                  {
                    id: 'hook43',
                    background: {
                      color: '#ffffff05',
                    },
                    positions: { pos: { x: 1540, y: 22, height: 220, width: 126 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        // positions: {
        //   type: 'absolute',
        //   pos: { x: 150, y: 50 },
        //   autoFit: true,
        // },
        positions: {
          pos: { autoFit: true },
          type: 'absolute',
          fixTab: [
            { x: 0, y: 20 },
            { x: 200, y: 10 },
            { x: 400, y: 50 },
            { x: 600, y: 10 },
            { x: 800, y: 30 },
            { x: 1000, y: 10 },
            { x: 1200, y: 30 },
            // { x: 1400, y: 10 },
            { x: 0, y: 250 },
            { x: 200, y: 330 },
            { x: 400, y: 320 },
            { x: 600, y: 340 },
            { x: 800, y: 350 },
            { x: 1000, y: 310 },
            { x: 1200, y: 340 },
            // { x: 1400, y: 330 },
            { x: 0, y: 610 },
            { x: 200, y: 620 },
            { x: 400, y: 650 },
            { x: 600, y: 620 },
            { x: 800, y: 640 },
            { x: 1000, y: 610 },
            { x: 1200, y: 630 },
            // { x: 1400, y: 620 },
          ],
        },
        itemsConfig: {
          // positions: {
          //   pos: { height: 55, width: 250 },
          //   margin: { right: 30, top: 30 },
          //   columns: 3,
          // },
          background: {
            color: 'transparent',
          },
        },
        items: [
          {
            id: '00',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
            positions: { pos: { height: 127, width: 127 } },
          },
          {
            id: '10',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
            positions: { pos: { height: 127, width: 127 } },
          },
          {
            id: '20',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
            positions: { pos: { height: 127, width: 127 } },
          },
          {
            id: '30',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
            positions: { pos: { height: 127, width: 127 } },
          },
          {
            id: '40',
            background: {
              image: { src: dirPath + '/img/20.png' },
            },
            positions: { pos: { height: 127, width: 127 } },
          },
          {
            id: '01',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
            positions: { pos: { height: 142, width: 164 } },
          },
          {
            id: '11',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
            positions: { pos: { height: 142, width: 164 } },
          },
          {
            id: '21',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
            positions: { pos: { height: 142, width: 164 } },
          },
          {
            id: '31',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
            positions: { pos: { height: 142, width: 164 } },
          },
          {
            id: '41',
            background: {
              image: { src: dirPath + '/img/21.png' },
            },
            positions: { pos: { height: 142, width: 164 } },
          },
          {
            id: '02',
            background: {
              image: { src: dirPath + '/img/23.png' },
            },
            positions: { pos: { height: 156, width: 156 } },
          },
          {
            id: '12',
            background: {
              image: { src: dirPath + '/img/23.png' },
            },
            positions: { pos: { height: 156, width: 156 } },
          },
          {
            id: '22',
            background: {
              image: { src: dirPath + '/img/23.png' },
            },
            positions: { pos: { height: 156, width: 156 } },
          },
          {
            id: '32',
            background: {
              image: { src: dirPath + '/img/23.png' },
            },
            positions: { pos: { height: 156, width: 156 } },
          },
          {
            id: '42',
            background: {
              image: { src: dirPath + '/img/23.png' },
            },
            positions: { pos: { height: 156, width: 156 } },
          },
          {
            id: '03',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
            positions: { pos: { height: 220, width: 126 } },
          },
          {
            id: '13',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
            positions: { pos: { height: 220, width: 126 } },
          },
          {
            id: '23',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
            positions: { pos: { height: 220, width: 126 } },
          },
          {
            id: '33',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
            positions: { pos: { height: 220, width: 126 } },
          },
          {
            id: '43',
            background: {
              image: { src: dirPath + '/img/22.png' },
            },
            positions: { pos: { height: 220, width: 126 } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  realHeight: 890,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      // y: -100,
      x: 0,
    },
    cssStyle: {
      positions: 'absolute',
      left: '-46px',
      top: '30px',
    },
  },
  configGame: configGame,
};

export default dataConfig;
